<template>
  <div class="page-container">
    <b-card class="mb-3">
      <b-media>
        <img
          src="../../../assets/iconfinder_location_718953.png"
          height="64"
          width="64"
          slot="aside"
          class="rounded"
        />
        <h5 class="mt-0">{{ form.name }}</h5>
        <p>{{ lastModifiedAt }} | {{ createdAt }}</p>
      </b-media>
    </b-card>
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <b-form @submit.prevent="onSubmit" class="col-12">
        <h5>
          Szczegóły dotyczące lokalizacji
          <hr />
        </h5>
        <div class="row">
          <b-form-group
            id="input-group-name"
            label="Nazwa lokalizacji:"
            label-for="input-name"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              type="text"
              required
              placeholder="Wpisz nazwę lokalizacji"
              :disabled="!isSuperAdmin"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-api-key"
            label="Klucz API:"
            label-for="input-api-key"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-api-url"
              v-model="form.api_key"
              type="text"
              required
              placeholder="Wpisz klucz API"
              :disabled="!isSuperAdmin"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-api-url"
            label="Url serwera API:"
            label-for="input-api-url"
            description=""
            class="col-12"
          >
            <b-form-input
              id="input-api-url"
              v-model="form.api_url"
              type="url"
              required
              placeholder="Wpisz url serwera API"
              :disabled="!isSuperAdmin"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-register-api-url"
            label="Url API Rejestracja Online:"
            label-for="input-register-api-url"
            description=""
            class="col-12"
          >
            <b-form-input
              id="input-register-api-url"
              v-model="form.registration_url"
              type="url"
              required
              placeholder="Wpisz url API Rejestracji Online"
              :disabled="!isSuperAdmin"
            ></b-form-input>
          </b-form-group>
          <h5 class="col-12 mt-2">
            Adres
            <hr />
          </h5>
          <b-form-group
            id="input-group-address"
            label="Ulica wraz z numerem budynku oraz lokalu:"
            label-for="input-address"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-address"
              v-model="form.address"
              type="text"
              placeholder="Wpisz ulicę wraz z numerem budynku oraz lokalu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-postal-code"
            label="Kod pocztowy:"
            label-for="input-posta-code"
            description=""
            class="col-2"
          >
            <b-form-input
              id="input-postal-code"
              v-model="form.postal_code"
              type="tel"
              placeholder="Wpisz kod pocztowy"
              v-mask="'##-###'"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-city"
            label="Miasto:"
            label-for="input-city"
            description=""
            class="col-4"
          >
            <b-form-input
              id="input-city"
              v-model="form.city"
              type="text"
              placeholder="Wpisz miasto"
            ></b-form-input>
          </b-form-group>
          <h5 class="col-12 mt-2">
            Dane kontaktowe
            <hr />
          </h5>
          <b-form-group
            id="input-group-register-problems-phone"
            label="Numer serwisowy (komórkowy):"
            label-for="input-register-problems-phone"
            description="Na ten numer telefonu będą przychodziły powiadomienia o nierozpoznanych SMS'ach zwrotnych od pacjentów oraz o braku potwierdzenia rejestracji."
            class="col-6"
          >
            <b-form-input
              id="input-register-problems-phone"
              v-model="form.contact_numbers.register_problems"
              type="tel"
              v-mask="'48 ### ### ###'"
              placeholder="Wpisz numer telefonu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-consultant-info-phone"
            label="Numer kontaktowy dla konsultantów:"
            label-for="input-consultant-info-phone"
            description="Ten numer telefonu wyświetli się konsultantom w przypadku kiedy będą chcieli skontaktować się z placówką w razie wątpliwości dt. pacjenta."
            class="col-6"
          >
            <b-form-input
              id="input-consultant-info-phone"
              v-model="form.contact_numbers.consultant_info"
              type="tel"
              v-mask="'48 ### ### ###'"
              placeholder="Wpisz numer telefonu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-landline"
            label="Numer kontaktowy dla pacjentów:"
            label-for="input-landline"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-landline"
              v-model="form.contact_numbers.landline"
              type="tel"
              required
              v-mask="'48 ### ### ###'"
              placeholder="Wpisz numer kontaktowy dla pacjenta"
            ></b-form-input>
          </b-form-group>
          <div class="col-12 row p-0">
            <div class="col-12 p-0">
              <b-button type="submit" variant="primary" class="float-right">Zapisz zmiany</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Modify',
  created() {
    const vm = this
    vm.form.id = vm.$route.params.id
    vm.fetchData()
    moment.locale('pl')
  },
  mounted() {
    this.accountType = localStorage.getItem('account_type')
  },
  data() {
    return {
      form: {
        contact_numbers: {
          register_problems: '',
          consultant_info: '',
          landline: ''
        }
      },
      visitGroups: [],
      allowedScopes: {},
      onlyExistingTags: true,
      limit: 0,
      scopes: 'Dostępne do wyboru: ',
      saving: false,
      invoiceDocuments: [],
      accountType: ''
    }
  },
  computed: {
    lastModifiedAt() {
      return `Ostatnio modyfikowana ${moment(this.form.updated_at).fromNow()}`
    },
    createdAt() {
      return `Utworzona ${moment(this.form.created_at).calendar().toLocaleLowerCase()}`
    },
    isSuperAdmin() {
      return this.accountType === 'super_admin'
    }
  },
  methods: {
    onSubmit() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'modify-consultant')
      vm.$http
        .post('e-zacma/localization/modify', vm.form)
        .then(() => {
          vm.$success('Dane lokalizacji zostały zapisane')
        })
        .catch(() => {
          vm.$error()
        })
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'modify-consultant')
          vm.$router.push({ name: 'e-zacma-localizations' })
        })
    },
    fetchData() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'fetch-consultant')
      vm.$http
        .post('e-zacma/localization/get', { id: vm.form.id })
        .then(response => {
          vm.parseJSON(response)
          vm.form = response.data
        })
        .catch(() => {
          vm.$error()
        })
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'fetch-consultant')
        })
    },
    parseJSON(response) {
      response.data.contact_numbers = JSON.parse(response.data.contact_numbers)
      response.data.sms_templates = JSON.parse(response.data.sms_templates)
      response.data.message_templates = JSON.parse(response.data.message_templates)
    }
  }
}
</script>

<style scoped lang="scss">
.b-tab {
  height: 100%;
}
</style>
